// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"4bb6ac56","447":"e6f6c536"}[chunkId] + ".chunk.css";
};